import axios from "axios";
import { API_SERVER_URL } from "settings/constant";

const COMFIG_BY_DOMAIN_API_URL = API_SERVER_URL + 'api/v1/by_front_configurations/by_domain';

export function getFrontConfig(queryParams) {
  const { domain, lang } = queryParams;
  return axios.get(`${COMFIG_BY_DOMAIN_API_URL}?locale=${lang}&domain=${domain}`);
}
